import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'telMask', pure: false
})
export class TelPipe implements PipeTransform {
  guardInput = '';
  inputString = '';

  transform(input: any): any {
    if (input) {
      this.inputString = input.toString();
    }

    if (this.inputString.length >= 11) {
      if (this.inputString.length > 14) {

        let inputLocal = this.inputString.substr(1, this.inputString.length - 1);
        for (let i = 0; i < 3; i++) {
          inputLocal = inputLocal.replace(')', '');
          inputLocal = inputLocal.replace('-', '');
          inputLocal = inputLocal.replace(' ', '');
        }
        return inputLocal;
      } else {
        this.guardInput = `(${
          this.inputString.substring(0, 2)
          }) ${this.inputString.substring(2, 3)
          } ${this.inputString.substring(3, 7)
          } ${this.inputString.substring(7, 12)
          }`
        return this.guardInput;
      }
    }


    return input;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/pipe/tel.pipe.ts